/**
 * The admin portal roles of the signed-in support user: the client roles Keycloak issues for the
 * portal's own client (`resource_access.<client id>.roles` in the token). They only decide what
 * the portal shows; every endpoint checks the role again.
 */

import { createContext, type ReactNode, useContext, useMemo } from 'react'

const PortalRolesContext = createContext<ReadonlySet<string>>(new Set())

export interface PortalRolesProviderProps {
  roles: readonly string[]
  children: ReactNode
}

export const PortalRolesProvider = ({ roles, children }: PortalRolesProviderProps) => {
  const value = useMemo(() => new Set(roles), [roles])
  return <PortalRolesContext.Provider value={value}>{children}</PortalRolesContext.Provider>
}

/** Whether the signed-in user has the portal role. Without a provider, nobody has any role. */
export const useHasPortalRole = (role: string): boolean => useContext(PortalRolesContext).has(role)
